import { usePublicSiteData } from "./PublicSiteContext";
import PublicSectionTitle from "./PublicSectionTitle";

const PublicBranches = () => {
  const website = usePublicSiteData();
  const branches = website?.branches ?? [];

  if (branches.length === 0) return null;

  return (
    <section className="psite-branches" id="branches">
      <div className="psite-section__inner">
        <PublicSectionTitle light title="Our Locations" />
        <div className="psite-branches__grid">
          {branches.map((branch) => (
            <div className="psite-branch" key={branch.id}>
              <span className="psite-branch__icon" aria-hidden="true">
                &#128205;
              </span>
              <h3>{branch.name}</h3>
              <p>
                {[branch.address, branch.area, branch.city]
                  .filter(Boolean)
                  .join(", ") || "—"}
              </p>
              <p>{branch.phone || "—"}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PublicBranches;